/** Quiz answer keys written to the lpAnswers cookie. Anything else is dropped. */
export const LP_ANSWERS_ALLOWED_KEYS = new Set([
  'interstitial',
  'termChoice',
  'householdIncludes',
  'energyPlanIncludes',
  'vehicleChargeTime',
  'nonTexasNative',
])
